import Amplify from 'aws-amplify';
import { Hub } from 'aws-amplify';
const region = process.env.VUE_APP_COGNITO_REGION;
const userPoolId = process.env.VUE_APP_COGNITO_USER_POOL_ID;
const userPoolWebClientId = process.env.VUE_APP_COGNITO_USER_POOL_WEB_CLIENT_ID;

export default Amplify.configure({
  Auth: {
    // REQUIRED - Amazon Cognito Region
    region,
    // OPTIONAL - Amazon Cognito User Pool ID
    userPoolId,
    // OPTIONAL - Amazon Cognito Web Client ID (26-char alphanumeric string)
    userPoolWebClientId
  }
});

const listener = (data) => {

  switch (data.payload.event) {

    case 'signIn':
      // console.log('user signed in');
      break;
    case 'signUp':
      // console.log('user signed up');
      break;
    case 'signOut':
      // console.log('user signed out');
      break;
    case 'signIn_failure':
      // console.log('user sign in failed');
      break;
    case 'configured':
    // console.log('the Auth module is configured');
  }
}

Hub.listen('auth', listener);